// @VH_DELETE_CANDIDATE: Legacy thin client - replaced by src/services/api/client.ts | delete_after=2026-02-15
/**
 * Thin client for selected endpoints with JSDoc types from generated definitions
 * Uses fetch with Authorization header if a token is present in localStorage
 *
 * NOTE (2026-01-27): Multiple API clients exist - see /src/services/api/client.js
 * for the full list and Phase 8 consolidation plan.
 * 
 * DEPRECATED: Use src/services/api/client.ts (canonical client) instead.
 */

import { API_BASE_URL, isProduction } from '../config/api.config';
import { decodeJwtPayload, getAuthHeaderAsync } from '../utils/authToken';
import logger from '../utils/logger';

const API_BASE = `${API_BASE_URL}/api`;

const createRequestId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `vh-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

async function authHeader() {
  try {
    return await getAuthHeaderAsync();
  } catch (_) {
    return {};
  }
}

async function httpGet(path, params) {
  const url = new URL(API_BASE + path, window.location.origin);
  if (params && typeof params === 'object') {
    Object.entries(params).forEach(([k, v]) => v != null && url.searchParams.set(k, String(v)));
  }
  const headers = { 'Content-Type': 'application/json', ...(await authHeader()) };
  const existingRequestId = headers['x-vh-req-id'] || headers['X-VH-Req-Id'];
  const requestId = existingRequestId || createRequestId();
  headers['x-vh-req-id'] = requestId;

  if (!isProduction()) {
    const authValue = headers.Authorization;
    const token = authValue?.startsWith('Bearer ') ? authValue.slice(7) : null;
    const tokenPayload = decodeJwtPayload(token);
    const tokenPrefix = token ? token.slice(0, 10) : '';
    const isSameOrigin = new URL(url.toString(), window.location.origin).origin === window.location.origin;
    logger.debug('[api/client] Request auth', {
      url: url.toString(),
      hasAuthHeader: !!authValue,
      tokenLength: token ? token.length : 0,
      tokenPrefix,
      tokenIss: tokenPayload?.iss,
      tokenAud: tokenPayload?.aud,
      tokenExp: tokenPayload?.exp,
      requestId,
      isSameOrigin,
    });
  }

  const res = await fetch(url.toString(), { headers });
  if (!res.ok) throw new Error(`GET ${path} ${res.status}`);
  return res.json();
}

/**
 * @returns {Promise<import('./types').paths['/api/dashboard/overview']['get']['responses']['200']['content']['application/json']>}
 */
export function getDashboardOverview() {
  return httpGet('/dashboard/overview');
}

/**
 * @param {{start?: string, end?: string}} q
 * @returns {Promise<import('./types').paths['/api/analytics/safety']['get']['responses']['200']['content']['application/json']>}
 */
export function getSafetyAnalytics(q) {
  return httpGet('/analytics/safety', q);
}
